import React, { useEffect, useState } from 'react';
import DownloadFallback from './DownloadFallback';
import { APP_STORE_URL, GOOGLE_PLAY_URL, WEBSITE_URL } from '../config/appLinks';

type Platform = 'ios' | 'android' | 'other';

const detectPlatform = (): Platform => {
  if (typeof navigator === 'undefined') return 'other';

  const ua = navigator.userAgent || '';

  if (/android/i.test(ua)) return 'android';

  // iPhone/iPad/iPod, plus iPadOS which reports itself as desktop Safari
  const isIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (isIOS) return 'ios';

  // Windows / macOS / Linux desktop -> website
  return 'other';
};

const targetForPlatform = (platform: Platform): string => {
  switch (platform) {
    case 'ios':
      return APP_STORE_URL;
    case 'android':
      return GOOGLE_PLAY_URL;
    default:
      return WEBSITE_URL;
  }
};

const DownloadRedirect: React.FC = () => {
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    const target = targetForPlatform(detectPlatform());
    window.location.replace(target);

    const timer = setTimeout(() => setShowFallback(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  return showFallback ? <DownloadFallback /> : null;
};

export default DownloadRedirect;
